import { faClipboard } from "@fortawesome/free-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as moment from "moment";
import { FC, useEffect, useState } from "react";
import PaginationComponent from "../pagination/pagination.component";

import { B2Table } from "@hdb/biome-2";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import faArrowDown from "../../../assets/icon/sort-down.svg";
import faArrowUp from "../../../assets/icon/sort-up.svg";
import SkeletonComponent from "../../../shared/custom-spinner/skeleton.component";
import capitalizeFirst from "../../../shared/helpers/upper-case";
import HasPermission, { useHasPermissionForAnyAction } from "../../guards/has-permission";
import isModuleAndActionAvailable from "../../guards/is-module-and-action-available";
import "./table.scss";
import ModalComponent from "../modal/modal.component";

interface TableHeader {
  label: string;
  title: string;
  width?: string;
  type?: "datetime" | string;
  redirectUrl?: string;
  isSorted?: boolean;
}

export interface EmptyConfig {
  title: string;
  description: string;
}

interface TableComponentProps {
  tableHeaders: TableHeader[] | any;
  allData?: any[];
  data: any[];
  totalNumberOfRecords: number;
  pageSize: number;
  current: number;
  onChangePage: any;
  onChangeSort?: any;
  actionConfig?: any;
  actionConfigName?: string;
  emptyConfig?: EmptyConfig;
  enableSelection?: boolean;
  autoSelectAll?: boolean;
  isLoadingData?: boolean;
  count?: number;
  wrapperHeight?: string;
  moduleName?: any;
  actionName?: any;
  isFaultTable?: boolean;
}

interface SelectedItem {
  page: any;
  value: any;
  status?: string;
}

const TableComponent: FC<TableComponentProps> = ({
  tableHeaders,
  allData = [],
  data,
  totalNumberOfRecords,
  pageSize,
  current,
  onChangePage,
  onChangeSort,
  actionConfig,
  actionConfigName = "Action",
  emptyConfig = null,
  enableSelection = false,
  autoSelectAll = false,
  isLoadingData = false,
  count = 11,
  wrapperHeight = "700px",
  moduleName,
  actionName,
  isFaultTable = false,
}) => {
  const navigate = useNavigate();
  const [hoverList, setHoverList] = useState([] as any);
  const [isDesc, setIsDesc] = useState(true);
  const [sortBy, setSortBy] = useState(null);
  const [disabledStatus, setDisabledStatus] = useState(false);
  const [areAllItemsSelectedOnThisPage, setAreAllItemsSelectedOnThisPage] =
    useState(false);
  const [isRenderModalOpen, setIsRenderModalOpen] = useState<boolean>(false);
  const [renderContent, setRenderContent] = useState<any>(null);
  const [selectedData, setSelectedData] = useState<{
    headerTitle: string;
    data: any;
  }>({
    headerTitle: "",
    data: {},
  });

  const dispatch = useDispatch();

  const modules = useSelector((state: any) => state.navbar.modules);

  const selectedItems: SelectedItem[] = useSelector(
    (state: any) => state.table.selectedItems
  );

  const handleRenderCloseModal = () => {
    setIsRenderModalOpen(false);
  };
  const renderModalContent = (getContent: any) => {
    setRenderContent(() => getContent);
    setIsRenderModalOpen(true);
  };

  const toggleSelect = (itemId: number, status: string) => {
    dispatch({
      type: "table/toggleSelect",
      payload: { page: current, value: itemId, status },
    });
  };

  const getItemValue = (item: any) => {
    if (item?.sensorId) {
      return item.sensorId;
    }

    if (item?.id) {
      return item.id;
    }

    if (item?.assetCode) {
      return item.assetCode;
    }

    if (item?.deviceCode) {
      return item.deviceCode;
    }

    if (item?.assetID) {
      return item.assetID;
    }

    return "";
  };

  const toggleSelectAll = (isFaultTable: boolean) => {
    let selectedItemsForPage: SelectedItem[] = [];
    let combinedSelectedItems;
    const allItemsSelected = areAllItemsSelectedOnThisPage;
    // deviceCode
    if (!allItemsSelected) {
      // allData.length
      //   ? (selectedItemsForPage = allData.map((item: any) => ({
      //       page: current,
      //       value: getItemValue(item),
      //     })))
      //   :
      if (isFaultTable) {
        selectedItemsForPage = data
          ?.filter((item: any) => item?.status !== "Resolved")
          ?.map((item: any) => ({
            page: current,
            value: getItemValue(item),
            status: item?.status,
          }));
      } else {
        selectedItemsForPage = data.map((item: any) => ({
          page: current,
          value: getItemValue(item),
        }));
      }

      combinedSelectedItems = [...selectedItems, ...selectedItemsForPage];
    } else {
      selectedItemsForPage = selectedItems.filter(
        (item: SelectedItem) => item.page !== current
      );

      combinedSelectedItems = [...selectedItemsForPage];
    }

    const uniqueValuesSet = combinedSelectedItems.filter(
      (item, index, self) =>
        index ===
        self.findIndex((t) => t.value === item.value && t.page === item.page)
    );

    dispatch({
      type: "table/toggleSelectAll",
      payload: uniqueValuesSet,
    });
  };

  useEffect(() => {
    if (enableSelection && autoSelectAll && data?.length) {
      toggleSelectAll(isFaultTable);
    }
  }, [enableSelection, autoSelectAll, data, current, isFaultTable]);

  useEffect(() => {
    let totalItemSelectedForThisPage = 0;

    if (enableSelection) {
      let selectedItemsForThisPage: any = [];

      // selectedItemsForThisPage = allData?.length
      //   ? selectedItems
      //   : selectedItems.filter((item: SelectedItem) => item.page === current);

      selectedItemsForThisPage = selectedItems?.filter(
        (item: SelectedItem) => item.page === current
      );

      if (isFaultTable) {
        const itemsResolvedInThisPage = data?.filter(
          (item: SelectedItem) => item?.status === "Resolved"
        );

        if (itemsResolvedInThisPage?.length == 10) {
          setAreAllItemsSelectedOnThisPage(false);
          return;
        }

        totalItemSelectedForThisPage =
          totalItemSelectedForThisPage + itemsResolvedInThisPage?.length;
      }

      let areAllItemsSelectedOnThisPage;

      totalItemSelectedForThisPage =
        totalItemSelectedForThisPage + selectedItemsForThisPage?.length;

      // areAllItemsSelectedOnThisPage = allData?.length
      //   ? totalItemSelectedForThisPage === allData?.length + 1
      //   : totalItemSelectedForThisPage === data?.length;

      areAllItemsSelectedOnThisPage =
        data?.length > 0 && totalItemSelectedForThisPage === data?.length;

      const cleanedSelectedItems = selectedItems?.filter(
        (item) => !(item?.page === null && item?.value === null)
      );

      setAreAllItemsSelectedOnThisPage(
        cleanedSelectedItems?.length > 0 && areAllItemsSelectedOnThisPage
      );
    }
  }, [current, data, enableSelection, selectedItems]);

  const handleMouseEnter = (item: any) => {
    const copyHoverList = [...hoverList];
    if (!copyHoverList.find((x) => x === item)) {
      copyHoverList.push(item);
    }
    setHoverList(copyHoverList);
  };

  const handleMouseLeave = (item: any) => {
    let copyHoverList = [...hoverList];
    if (copyHoverList.find((x) => x === item)) {
      copyHoverList = copyHoverList.filter((x) => x !== item);
    }
    setHoverList(copyHoverList);
  };

  const handleSort = (label: any) => {
    setSortBy(label);
    setIsDesc(!isDesc);
  };

  useEffect(() => {
    const sortOrder = isDesc ? "desc" : "asc";

    if (onChangeSort) onChangeSort(capitalizeFirst(sortBy), sortOrder);
  }, [isDesc]);

  const getDisabledStatus = async () => {
    if (moduleName && actionName) {
      const isAvailable = await isModuleAndActionAvailable(
        moduleName,
        actionName,
        modules
      );

      setDisabledStatus(!isAvailable);
    }
  };

  useEffect(() => {
    getDisabledStatus();
  }, []);

  useEffect(() => {
    // Cleanup: clear selectedItems when component unmounts
    return () => {
      dispatch({
        type: "table/toggleSelectAll",
        payload: [{ page: null, value: null, status: null }],
      });
    };
  }, []);

  const hasPermissionForAnyAction = useHasPermissionForAnyAction(actionConfig);

  return (
    <>
      <SkeletonComponent
        wrapperHeight={wrapperHeight}
        skeletonHeight="50px"
        isLoading={isLoadingData}
        count={count}
        isShowCardStyle={true}
      >
        {data?.length ? (
          <>
            <B2Table hover striped responsive="true">
              <B2Table.Head headVariant="dark">
                <tr className="text-center">
                  {enableSelection && !disabledStatus && (
                    <th>
                      <input
                        type="checkbox"
                        style={{ cursor: "pointer" }}
                        checked={areAllItemsSelectedOnThisPage}
                        onChange={() => toggleSelectAll(isFaultTable)}
                      />
                    </th>
                  )}

                  {tableHeaders &&
                    tableHeaders?.length > 0 &&
                    tableHeaders?.map((item: any) => {
                      let sortIcon;
                      if (item?.excludeSort) {
                        sortIcon = <> </>;
                      } else if (isDesc) {
                        sortIcon = <img src={faArrowDown} alt="arrowDown" />;
                      } else {
                        sortIcon = <img src={faArrowUp} alt="arrowUp" />;
                      }

                      return <th key={item?.label}>
                        <div
                          style={{
                            width: item?.width ? item?.width : "", // 12rem
                          }}
                          className="d-flex justify-center items-center"
                          onMouseEnter={() => handleMouseEnter(item)}
                          onMouseLeave={() => handleMouseLeave(item)}
                        >
                          {item?.title}
                          <button
                            type="button"
                            aria-label={`Sort by ${item?.title || item?.label}`}
                            disabled={item?.excludeSort}
                            onClick={() => handleSort(item?.label)}
                            className={`flex ms-2 ${(item.hasOwnProperty("isSorted") &&
                              item.isSorted) ||
                              hoverList?.find((x: any) => x === item)
                              ? "activeSort"
                              : "disabled"
                              } table-sort-button`}
                            onMouseEnter={() => handleMouseEnter(item)}
                            onMouseLeave={() => handleMouseLeave(item)}
                            onFocus={() => handleMouseEnter(item)}
                            onBlur={() => handleMouseLeave(item)}
                            style={{
                              cursor: !item?.excludeSort
                                ? "pointer"
                                : "not-allowed",
                            }}
                          >
                            {sortIcon}
                          </button>
                        </div>
                      </th>;
                    })}

                  {actionConfig && hasPermissionForAnyAction && <th>{actionConfigName}</th>}
                </tr>
              </B2Table.Head>

              <B2Table.Body>
                {data &&
                  data?.length > 0 &&
                  data.map((data: any, j: number) => {
                    const selectionValue = [
                      data?.sensorId,
                      data?.id,
                      data?.assetCode,
                      data?.deviceCode,
                      data?.assetID,
                    ].find(Boolean) ?? "";

                    return (
                      <tr key={`${selectionValue}-${j}`} className="text-center">
                        {enableSelection && !disabledStatus && (
                          <td>
                            <input
                              type="checkbox"
                              style={{ cursor: "pointer" }}
                              checked={selectedItems?.some((item) => item.value === selectionValue)}
                              onChange={() => toggleSelect(selectionValue, data?.status)}
                              disabled={data?.status == "Resolved"}
                            />
                          </td>
                        )}

                        {tableHeaders?.map((item: any, l: any) => {
                          const hasModalContent =
                            item.hasOwnProperty("headerTitle") &&
                            item.headerTitle &&
                            item.hasOwnProperty("modalRenderProps") &&
                            item.modalRenderProps;

                          const handleCellModalOpen = (target: HTMLElement) => {
                            if (!target.querySelector(".link-color.cursor-pointer")) {
                              return;
                            }

                            if (hasModalContent) {
                              setSelectedData({
                                headerTitle: item.headerTitle,
                                data: data,
                              });
                              renderModalContent(item.modalRenderProps);
                            }
                          };

                          let cellContent;
                          if (item?.type === "scrollable-html") {
                            cellContent = (
                              <div className="scrollable-cell-wrapper">
                                <div
                                  className="scrollable-cell-content"
                                  style={{
                                    maxHeight: item?.maxHeight || '115px'
                                  }}
                                  dangerouslySetInnerHTML={{
                                    __html: data[item?.label] || ''
                                  }}
                                />
                              </div>
                            );
                          } else if (item?.type === "datetime") {
                            cellContent = data[item.label]
                              ? ` ${moment.utc(data[item.label]).format("DD-MM-YYYY HH:mm:ss")}`
                              : "-";
                          } else if (item?.type === "date") {
                            cellContent = data[item.label]
                              ? ` ${moment(data[item.label]).format("DD-MM-YYYY ")} `
                              : "-";
                          } else if (item?.type === "link") {
                            cellContent = (
                              <button
                                type="button"
                                style={{
                                  color: "#1976D2",
                                  cursor: "pointer",
                                  appearance: "none",
                                  border: "none",
                                  background: "none",
                                  padding: 0,
                                  font: "inherit",
                                }}
                                onClick={() => {
                                  if (item?.hasOwnProperty("isOpenInNewTable")) {
                                    const newTab = window.open(
                                      `${item?.link}/${btoa(data[item.label])}`,
                                      "_blank"
                                    );

                                    newTab?.focus();
                                  } else {
                                    navigate(
                                      item.hasOwnProperty("linkableField") && item.linkableField
                                        ? `${item?.link}/${btoa(data[item.linkableField])}`
                                        : `${item?.link}/${btoa(data[item.label])}`
                                    );
                                  }
                                }}
                              >
                                {data[item.label]}
                              </button>
                            );
                          } else if (item.renderProps) {
                            cellContent = item.renderProps(data);
                          } else if (
                            typeof data[item.label] === "string" &&
                            data[item.label]?.length
                          ) {
                            const fullText = capitalizeFirst(data[item.label]);

                            if (item.textLength && 
                              typeof item.textLength === "number" && 
                              fullText.length > item.textLength) 
                              {
                              cellContent = fullText.slice(0, item.textLength) + " ...";
                            } else {
                              cellContent = fullText;
                            }
                          } else if (typeof data[item.label] === "number") {
                            cellContent = data[item.label];
                          } else if (typeof data[item.label] === "boolean") {
                            if (data[item.label]) {
                              cellContent = "True";
                            } else {
                              cellContent = "False";
                            }
                          } else {
                            cellContent = "-";
                          }

                          let cellWrapper;
                          if (item?.type === "scrollable-html") {
                            cellWrapper = cellContent;
                          } else if (hasModalContent) {
                            cellWrapper = (
                              <button
                                type="button"
                                onClick={(e) => handleCellModalOpen(e.currentTarget)}
                                onTouchEnd={(e) => handleCellModalOpen(e.currentTarget)}
                                className="flex justify-center items-center m-2"
                                style={{
                                  appearance: "none",
                                  border: "none",
                                  background: "none",
                                  padding: 0,
                                  font: "inherit",
                                  color: "inherit",
                                }}
                              >
                                {cellContent}
                              </button>
                            );
                          } else {
                            cellWrapper = (
                              <div className="flex justify-center items-center m-2">
                                {cellContent}
                              </div>
                            );
                          }

                          return (
                            <td
                              key={item?.label ?? item?.headerTitle ?? item?.type}
                              colSpan={item?.colspan || null}
                            >
                              {cellWrapper}
                            </td>
                          );
                        })}

                        {actionConfig && !!actionConfig?.length && hasPermissionForAnyAction && (
                          <td>
                            <div className="flex justify-content-center">
                              {actionConfig?.map((action: any, k: number) =>
                                action?.moduleName ? (
                                  <div
                                    key={`${action?.id ?? action?.key ?? action?.moduleName ?? "action"}-${action?.actionName ?? action?.actionProperty ?? action?.label ?? "item"}`}
                                  >
                                    <HasPermission
                                      moduleName={action?.moduleName}
                                      actionName={action?.actionName}
                                      isRoute={false}
                                    >
                                      <button
                                        type="button"
                                        className={`table-actions  m-2 ${(action.hasOwnProperty("isDisplay") &&
                                          action.isDisplay(
                                            data,
                                            action.label
                                          )) ||
                                          !action.hasOwnProperty("isDisplay")
                                          ? ""
                                          : "d-none"
                                          } ${(action.hasOwnProperty("isDisabled") &&
                                            action.isDisabled(
                                              data,
                                              action.label
                                            )) ||
                                            !action.hasOwnProperty("isDisabled")
                                            ? ""
                                            : "disabled cursor-auto"
                                          }`}
                                        style={{
                                          appearance: "none",
                                          border: "none",
                                          background: "none",
                                          padding: 0,
                                          font: "inherit",
                                        }}
                                        onClick={() =>
                                          (action.hasOwnProperty("isDisplay") &&
                                            action.isDisplay(
                                              data,
                                              action.label
                                            )) ||
                                            (action.hasOwnProperty("isDisabled") &&
                                              action.isDisabled(
                                                data,
                                                action.label
                                              )) ||
                                            (!action.hasOwnProperty("isDisplay") &&
                                              !action.hasOwnProperty("isDisabled"))
                                            ? action.event(
                                              data[action.actionProperty]
                                            )
                                            : null
                                        }
                                      >
                                        {action.label}
                                      </button>
                                    </HasPermission>
                                  </div>
                                ) : (
                                  <button
                                    type="button"
                                    key={`${action?.id ?? action?.key ?? action?.moduleName ?? "action"}-${action?.actionName ?? action?.actionProperty ?? action?.label ?? "item"}`}
                                    className={`table-actions  m-2 ${(action.hasOwnProperty("isDisplay") &&
                                      action.isDisplay(data, action.label)) ||
                                      !action.hasOwnProperty("isDisplay")
                                      ? ""
                                      : "disabled"
                                      }`}
                                    style={{
                                      appearance: "none",
                                      border: "none",
                                      background: "none",
                                      padding: 0,
                                      font: "inherit",
                                    }}
                                    onClick={() =>
                                      (action.hasOwnProperty("isDisplay") &&
                                        action.isDisplay(data, action.label)) ||
                                        !action.hasOwnProperty("isDisplay")
                                        ? action.event(
                                          data[action.actionProperty]
                                        )
                                        : null
                                    }
                                  >
                                    {action.label}
                                  </button>
                                )
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
              </B2Table.Body>
            </B2Table>

            <div className="mt-3">
              {onChangePage && totalNumberOfRecords && pageSize && current ? (
                <PaginationComponent
                  totalNumberOfRecords={totalNumberOfRecords}
                  pageSize={pageSize}
                  current={current}
                  onChangePage={onChangePage}
                />
              ) : null}
            </div>
          </>
        ) : (
          <div className="mt-5">
            {emptyConfig ? (
              <div className="flex justify-center items-center">
                <div
                  className="flex flex-col justify-center items-center"
                  style={{
                    width: "60%",
                    padding: "5rem",
                    borderRadius: "8px",
                    backgroundColor: "#EBEBEB",
                  }}
                >
                  <div style={{ fontSize: "70px" }}>
                    <FontAwesomeIcon icon={faClipboard} className="mb-3" />
                  </div>
                  <h2 style={{ fontWeight: 700 }}>{emptyConfig?.title}</h2>
                  <div>{emptyConfig?.description}</div>
                </div>
              </div>
            ) : (
              <div className="flex justify-center items-center">
                <div
                  className="flex flex-col justify-center items-center"
                  style={{
                    width: "60%",
                    padding: "5rem",
                    borderRadius: "8px",
                    backgroundColor: "#EBEBEB",
                  }}
                >
                  <div style={{ fontSize: "70px" }}>
                    <FontAwesomeIcon icon={faClipboard} className="mb-3" />
                  </div>
                  <h2 style={{ fontWeight: 700 }}>No Records Found</h2>
                  <div>Add some new data please.</div>
                </div>
              </div>
            )}
          </div>
        )}
      </SkeletonComponent>

      {isRenderModalOpen && (
        <ModalComponent
          showModal={isRenderModalOpen}
          handleClose={handleRenderCloseModal}
          headerTitle={selectedData.headerTitle}
        >
          {renderContent ? (
            renderContent(selectedData.data)
          ) : (
            <div>No data</div>
          )}
        </ModalComponent>
      )}
    </>
  );
};

export default TableComponent;
